import { ActionButton } from "./ActionButton";

export const CancelSaveActionButtons = ({
  onCancelClick,
  onSaveClick,
  cancelDisabled,
  saveDisabled,
}) => {
  return (
    <>
      <ActionButton
        variant={"red"}
        onClick={() => {
          onCancelClick();
        }}
        disabled={cancelDisabled}
      >
        Cancel All
      </ActionButton>
      <ActionButton
        variant={"blue"}
        onClick={() => {
          onSaveClick();
        }}
        disabled={saveDisabled}
      >
        Save All
      </ActionButton>
    </>
  );
};

export default CancelSaveActionButtons;
